export default __webpack_public_path__ + "static/media/funtrab.b8681339.png";